import { Box } from '@mui/material';
import React from 'react';
import { createBrowserRouter, RouterProvider, useLocation } from 'react-router-dom';
import { GlobalError } from '../GlobalError/GlobalError';
import { NavigationContextProvider } from '../NavigationContext';
import { GlobalAppRootElement, mapGlobalAppRouteObject, tabsPath } from './components';
import { GlobalAppContext } from './GlobalAppContext';
export const GlobalApp = (props) => {
    var _a;
    const ref = React.useRef(null);
    const globalContextValue = React.useRef({
        setProfileBadge: (badge) => {
            var _a;
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.setProfileBadge(badge);
        },
        setMenuItemBadge: (path, badge) => {
            var _a;
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.setMenuItemBadge(path, badge);
        },
        setInfoProps: (props) => {
            var _a;
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.setInfoProps(props);
        },
        getTabs: () => {
            var _a, _b;
            return (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getTabs()) !== null && _b !== void 0 ? _b : [];
        },
        setTabs: (tabs, selectedTabPath) => {
            var _a;
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.setTabs(tabs, selectedTabPath);
        },
        openExistingTab: (tabPath) => {
            var _a;
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.openExistingTab(tabPath);
        },
        openTab: (tab) => {
            var _a;
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.openTab(tab);
        },
        closeTab: (tabPath) => {
            var _a;
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.closeTab(tabPath);
        },
        setTabBadge: (tabPath, badge) => {
            var _a;
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.setTabBadge(tabPath, badge);
        },
        setDrawerOpen: (open) => {
            var _a;
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.setDrawerOpen(open);
        },
        toggleDrawerOpen: () => {
            var _a;
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.toggleDrawerOpen();
        },
    });
    const children = createRootRouteChildren(props.routes, (_a = props.bottomMenuRoutes) !== null && _a !== void 0 ? _a : [], props.basename);
    const rootElement = React.createElement(GlobalAppRootElement, Object.assign({}, props, { ref: ref }));
    const router = createBrowserRouter([
        {
            path: '/*',
            element: props.rootElement ? props.rootElement(rootElement) : rootElement,
            children: children,
            errorElement: React.createElement(GlobalError, null),
        },
    ], { basename: props.basename });
    return (React.createElement(NavigationContextProvider, null,
        React.createElement(GlobalAppContext.Provider, { value: globalContextValue.current },
            React.createElement(RouterProvider, { router: router }))));
};
function createRootRouteChildren(routes, bottomMenuRoutes, basename) {
    const children = [...routes, ...bottomMenuRoutes].map((route) => mapGlobalAppRouteObject(route, basename !== null && basename !== void 0 ? basename : '/'));
    children.push({
        path: `${tabsPath}/*`,
        element: React.createElement(SelectGlobalTabByPath, null),
    });
    if (children.findIndex((route) => route.path === '*') === -1) {
        children.push({
            path: '*',
            element: React.createElement(GlobalError, { type: 'not-found' }),
        });
    }
    return children;
}
const SelectGlobalTabByPath = () => {
    const location = useLocation();
    React.useEffect(() => {
        const mainContentTabs = document.querySelectorAll('.main-content-tab');
        let tabFound = false;
        const tryingToAccessTabs = location.pathname.startsWith(`/${tabsPath}/`);
        if (tryingToAccessTabs) {
            const currentTabPath = location.pathname.substring(tabsPath.length + 2);
            for (const mainContentTab of mainContentTabs) {
                const tabPath = mainContentTab.getAttribute('data-tab-path');
                if (currentTabPath === tabPath || currentTabPath.startsWith(tabPath + '/')) {
                    mainContentTab.style.display = 'block';
                    tabFound = true;
                }
                else {
                    mainContentTab.style.display = 'none';
                }
            }
        }
        const mainContentWrapper = document.getElementById('main-content-wrapper');
        if (mainContentWrapper) {
            mainContentWrapper.style.display = tryingToAccessTabs && !tabFound ? 'block' : 'none';
        }
        return () => {
            for (const mainContentTab of mainContentTabs) {
                mainContentTab.style.display = 'none';
            }
            if (mainContentWrapper) {
                mainContentWrapper.style.display = 'block';
            }
        };
    }, [location.pathname]);
    return React.createElement(Box, null, "TAB NOT FOUND");
};
